export const convertCompanyStrongPoint = (strong_point: string) => {
  switch (strong_point) {
    case '':
      return '未登録';
    case 'sell_high':
      return '高く売るのが得意';
    case 'sell_fast':
      return '早く売るのが得意';
    case 'not_decline':
      return 'どんな物件も断らない';
  }
};
